import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import "./Login.scss";
import Layout from "./Layout";
import { DefaultRoute } from "../routes";
import executeApiRequest from "../common/executeApiRequest";
import NEXUS_CONST from "../common/constants";
import { set, setLocal } from "../common/utils";
import jwtDecode from "jwt-decode";
import { authConfig } from "./authConfig";
import { IDecodedToken, isNotNil, addMinutesToAuthTime } from "./utils";

export const Login = () => {
  const auth = useAuth();

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = window.ENV.cookieConsentScriptURL;
    script1.type = "text/javascript";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = window.ENV.cookieScriptTemplateURL;
    script2.setAttribute("data-document-language", "true");
    script2.type = "text/javascript";
    script2.charset = "UTF-8";
    script2.setAttribute("data-domain-script", window.ENV.domainScriptId);
    script2.async = true;
    document.body.appendChild(script2);

    const script3 = document.createElement("script");
    script3.type = "text/javascript";
    script3.text = "function OptanonWrapper() { }";
    document.body.appendChild(script3);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
      document.body.removeChild(script3);
    };
  }, []);

  if (auth.error) {
    return (
      <div className="error">
        Oops something went wrong...
        <p>
          Refresh the browser and try again <br />
          <code> {auth.error.message}</code>
        </p>
      </div>
    );
  }

  if (auth.isLoading) {
    return <div className="loading">Loading...</div>;
  }

  if (auth.isAuthenticated) {
    if (auth.user && auth.user.profile) {
      const { id_token, access_token } = auth.user;
      const { tenant_id, family_name, given_name, preferred_username } =
        auth.user.profile;

      if (!window.location.pathname.includes(`/projects/${tenant_id}`)) {
        window.location.href = `/projects/${tenant_id}`;
      }

      const oidcStorage = sessionStorage.getItem(
        `oidc.user:${authConfig.authority}:${authConfig.client_id}`
      );

      if (isNotNil(oidcStorage)) {
        const decodedToken = jwtDecode(
          JSON.parse(oidcStorage).id_token
        ) as IDecodedToken;
        const authTime = addMinutesToAuthTime(
          decodedToken.auth_time,
          window.ENV.SESSION_TIMEOUT_MINS
        );
        setLocal("userSessionTimeout", authTime);
      }

      executeApiRequest({
        url: `${window.ENV.SPA_AUTHORITY}${NEXUS_CONST.SEARCH_USER_IDENTITY}?query=${given_name}&projectId=${tenant_id}&type=USER`,
        method: "GET",
        accessToken: access_token,
      })
        .then((response) => {
          const email = response.data.results[0].email;
          set("mailid", email);
        })
        .catch((error) => {
          console.error("error", error);
        });

      set("accessToken", access_token);
      set("idToken", id_token);
      set("tenantId", tenant_id);
      set("username", `${family_name}, ${given_name}`);
      set("hid", preferred_username);
    }

    return (
      <Layout>
        <DefaultRoute />
      </Layout>
    );
  }

  auth.signinRedirect();

  return <></>;
};

export default Login;
